export type Sponsor = {
  name: string;
  tag: string;
  logo?: string;
  primary?: boolean;
};

export const SPONSORS: readonly Sponsor[] = [
  { name: 'Nexera', tag: 'autonomous AI agents for live conversation', logo: '/assets/nexera-dark.png', primary: true },
  { name: 'AI Minute with Suchi', tag: 'the parent show — a weekly AI briefing', logo: '/assets/ai-minute-mondays.png', primary: true },
  { name: 'YakFile', tag: 'agent-aware version control' },
  { name: 'Quackr', tag: 'observability for LLM apps' },
  { name: 'PondCDN', tag: 'edge inference, edge of sanity' },
  { name: 'GitGud', tag: 'PR review for the agent age' },
  { name: 'Bathtub Labs', tag: 'open-source eval harnesses' },
  { name: 'Floatie', tag: 'developer wellness, lol' },
];
